export default __webpack_public_path__ + "static/media/dogs.eee3c748.webp";